/** @format */

const COLORS = {
    MAIN: {
        PRIMARY: '#FF7900',
        SECONDARY: '#F16E00',
        DARK: '#000',
        LIGHT: '#FFF',
        DARKGRAY: '#d8d8d8',
    },
    FUNCTION: {
        SUCCESS: '#32C832',
        INFO: '#527EDB',
        WARNING: '#FFCC00',
        DANGER: '#CD3C14',
    },
    DARK_FUNCTION: {
        FUNCTION_1: '#333',
        FUNCTION_2: '#666',
        FUNCTION_3: '#999',
        FUNCTION_4: '#CCC',
        FUNCTION_5: '#DDD',
        FUNCTION_6: '#EEE',
    },
    ADDITIONAL: {
        ADDITIONAL_1: '#4BB4E6',
        ADDITIONAL_2: '#50BE87',
        ADDITIONAL_3: '#FFB4E6',
        ADDITIONAL_4: '#A885D8',
        ADDITIONAL_5: '#FFD200',
        ADDITIONAL_DARK: '#595959',
    },
};

export default COLORS;
